import { render, staticRenderFns } from "./Setup_TransactionTypesN.vue?vue&type=template&id=684f70f4&"
import script from "./Setup_TransactionTypesN.vue?vue&type=script&lang=js&"
export * from "./Setup_TransactionTypesN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports